import type { SortingState } from '@tanstack/react-table';
import type { Optional } from '@types';

import isEmpty from 'lodash/isEmpty';

import { type ISearchParameters, OPERATOR_SORT } from '@features/filters/types';

export const convertSortingToSearchPayload = (
  data: SortingState,
  defaultSort?: Optional<ISearchParameters['sorts']>
): ISearchParameters['sorts'] => {
  if (isEmpty(data)) {
    return defaultSort ?? [];
  }
  const sorting = data.map((sort) => ({
    order: sort.desc ? OPERATOR_SORT.DESC : OPERATOR_SORT.ASC,
    field: sort.id.replaceAll(/[A-Z]/gv, (match) => `_${match.toLowerCase()}`),
  }));

  return sorting;
};
